/* import __COLOCATED_TEMPLATE__ from './password.hbs'; */
import TwoFactorScaPasswordComponent from '@square/ember-multipass-components/components/ember-multipass-components/two-factor/sca/password';
export default class TwoFactorScaPasswordModalComponent extends TwoFactorScaPasswordComponent {}